import { Interpreter } from 'eval5/dist/esm'

const interpreter = new Interpreter(globalThis, { ecmaVersion: 6 })

function overrideQualtricsEvalFunc(
  records: MutationRecord[],
  observer: MutationObserver
): void {
  for (const record of records) {
    for (const addedNode of record.addedNodes) {
      if (addedNode.nodeName !== 'SCRIPT') {
        continue
      }
      const scriptNode = addedNode as HTMLScriptElement
      if (scriptNode.src.includes('CoreModule.js')) {
        scriptNode.onload = function (): void {
          if (window.QSI) {
            window.QSI.doEvalJS = function (js: string): unknown {
              return interpreter.evaluate(js)
            }
          }
        }
        observer.disconnect()
      }
    }
  }
}

const observerOptions: MutationObserverInit = {
  childList: true,
  subtree: true
}

const observer = new MutationObserver(overrideQualtricsEvalFunc)
observer.observe(document.body, observerOptions)
